<template>
  <gkModal
    class="video-modal"
    :class="{ 'video-modal--compact': data.compact }"
    :model="isShow"
    @destroy="close"
    color="videoModal"
    transition="gk-fade-up"
  >
    <video v-if="data.video" :src="data.video" controls="controls" :autoplay="true"></video>
    <div v-else class="content">
      <SubjectDetailModal v-if="data.isSubjectDetail" :data="data.subjectDetail" />
      <!-- 相同的功能，不同的文案分为两个组件 -->
      <!-- 赛道说明模块 -->
      <ModalNote :data="data" v-else-if="data.isShowBtn" />

      <!-- 区块链赛道模块 -->
      <ModalBlock :data="data" v-else />

    </div>
    <div slot="footer"></div>
  </gkModal>
</template>

<script>
import ModalNote from './components/ModalNote.vue'
import ModalBlock from './components/ModalBlock.vue'
import SubjectDetailModal from './components/SubjectDetailModal.vue'

import gkModal from './components/gkModal.vue'

export default {
  name: 'Modal',
  data: () => ({
    isShow: false
  }),

  components: {
    gkModal,
    ModalNote,
    ModalBlock,
    SubjectDetailModal
  },

  props: {
    data: {
      type: Object,
      default: () => {
        return { video: ''}
      }
    },
    isShowBtn: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    close () {
      this.$emit('close', this)
    }
  },

  created () {
    setTimeout(() => { this.isShow = true })
  }
}
</script>

<style lang="scss" scoped>

.video-modal::v-deep [gk-modal-mask] {
   background: rgba(0,0,0,.8);
}

.video-modal--compact::v-deep {
  .gk-modal__container {
    width: 420px;
    max-width: 90vw;
    background: #FFFFFF;
    border-radius: 8px;
  }

  .gk-modal__content {
    min-height: 0;
    max-height: none;
    overflow: visible;
  }

  .btn-close {
    top: 12px;
    right: 12px;
  }

  .content-scroll {
    display: none;
    min-height: 0;
  }
}

.video-modal--compact .content {
  min-height: 0;
  max-height: none;
  padding: 56px 32px 48px;
  border-radius: 8px;
  overflow: visible;

  @include mobile {
    min-height: 0;
    max-height: none;
    padding: 48px 24px 40px;
  }
}

video {
  width: 100%; height: 100%;
  border-radius: 4px;
}

.content {
  box-sizing: border-box;
  position: relative;
  padding: 30px;
  min-height: 75vh;
  max-height: 80vh;
  background: #FFFFFF;
  overflow: auto;
  @include mobile {
    width: 100%;
    padding: 12px;
    min-height: 0;
    max-height: calc(94dvh - 20px);
    overflow: auto;
  }
}

</style>
